import axios from "axios";
import { apiPortal } from "../../config";
const point = apiPortal + "/laporan";
const Laporan = {
    async getData() {
        try {
            const data = await axios.get(point, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "application/json",
                },
            });
            return data.data;
        } catch (error) {
            if (errro.response) {
                throw error.response.data.message;
            }
            throw error;
        }
    },
    async getAll(page = 1, category = null) {
        try {
            const data = await axios.get(`${point}-all`, {
                params: {
                    page,
                    category,
                },
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "application/json",
                },
            });
            return data.data;
        } catch (error) {
            if (errro.response) {
                throw error.response.data.message;
            }
            throw error;
        }
    },
};
export default Laporan;
